import React, { Component } from 'react';
import moment from 'moment';
import ContentWrapper from '../content_wrapper/ContentWrapper';
import {
  Icon,
  Descriptions,
  Popconfirm,
  Button,
  Empty,
  Drawer,
  Spin,
  Tag,
  Alert,
  Dropdown,
  Menu
} from 'antd';
import AnimateEnter from '../AnimateEnter';
import {CAMPAIGN_STATUSES} from '../../Utils';
import { CAMPAIGNS_RESOURCE_NAME, SHOW_MSISDNS } from '../../config/constants';
import { _callResource } from '../../context/_callResource';
import CampaignMsisdns from "./CampaignMsisdns";
import TEXTS from '../../locale/texts';

class CampaignDetails extends Component {
  state = {
    isMounted: false,
    drawerVisible: false,

    // campaigns resource
    oneOfCampaignsData: null,
    oneOfCampaignsDataIsLoading: true,
    oneOfCampaignsDataError: null,

    // campaigns export resource
    campaignsExportIsLoading: false,
    campaignsExportError: false,

    campaignsExportMsisdnsIsLoading: false,
    campaignsExportMsisdnsError: false,

    campaignsExportOperatorsIsLoading: false,
    campaignsExportOperatorsError: false,

    // campaigns delete resource
    campaignsDeleteIsLoading: false,
    campaignsDeleteError: false
  };

  callResource = _callResource.bind(this);

  toAllCampaigns = () => {
    this.props.history.push('/');
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    const { id, promiseCancelToken } = this.props;
    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'getOneOf',
      apiCallParams: { id },
      promiseCancelToken
    });
  }

  toEditCampaign = () => {
    const { id, history } = this.props;
    history.push({
      pathname: `/sms-campaigns/edit/${id}`,
      state: { ...this.state.oneOfCampaignsData }
    });
  };

  exportMessage = ({ key }) => {
    const { id, name } = this.state.oneOfCampaignsData;
    const { promiseCancelToken } = this.props;
    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'download',
      apiCallParams: { id, name, exportType: key },
      promiseCancelToken,
      notification: {
        text: TEXTS.campaignIsExported[this.props.lang]
      }
    });
  };

  mobileOperatorsReport = ({ exportType }) => {
    const { id, name } = this.state.oneOfCampaignsData;
    const { promiseCancelToken, lang } = this.props;
    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'download',
      apiCallParams: { id, name, exportType },
      promiseCancelToken,
      notification: {
        text: TEXTS.mobileOperatorsReportIsExported[lang]
      }
    });
  };

  deleteCampaign = async () => {
    const { id } = this.state.oneOfCampaignsData;
    const { promiseCancelToken } = this.props;
    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'delete',
      apiCallParams: { ids: [id] },
      promiseCancelToken,
      notification: {
        text: TEXTS.campaignIsDeleted[this.props.lang]
      },
      onSuccess: this.toAllCampaigns
    });
  };

  showDrawer = () => {
    this.setState({
      drawerVisible: true
    });
  };

  hideDrawer = () => {
    this.setState({
      drawerVisible: false
    });
  };

  copyCampaign = () => {
    const { history } = this.props;
    history.push({
      pathname: '/sms-campaigns/create',
      state: this.state.oneOfCampaignsData
    });
  };

  renderMenu = (smsCount) => {
    const { status } = this.state.oneOfCampaignsData;
    const { lang } = this.props;

    return (
      <Menu onClick={this.exportMessage}>
        <Menu.Item key="campaigns">
          {TEXTS.btnExportCampaign[lang]}
        </Menu.Item>
        {smsCount !== 0 &&
          <Menu.Item key="exportMsisdns">
            {TEXTS.btnExportRecipientList[lang]}
          </Menu.Item>
        }
        {status !== 'DRAFT' &&
          <Menu.Item key="mobileOperatorsReport">
            {TEXTS.btnExportOperatorsReport[lang]}
          </Menu.Item>
        }
      </Menu>
    )
  };

  renderModalForm = () => {
    const { id, lang } = this.props;
    const { oneOfCampaignsData:
      { isMsisdnsWithData }
    } = this.state;

    return (
      <CampaignMsisdns
        lang={lang}
        id={id}
        isMsisdnsWithData={isMsisdnsWithData}
      />
    );
  };

  renderData = () => {
    const { lang } = this.props;
    const {
      oneOfCampaignsData: campaign,
      oneOfCampaignsDataError,
      campaignsExportIsLoading,
      campaignsExportOperatorsIsLoading,
      campaignsExportMsisdnsIsLoading,
      campaignsDeleteIsLoading,
      isMounted,
      drawerVisible
    } = this.state;
    const isExportLoading = campaignsExportIsLoading || campaignsExportMsisdnsIsLoading || campaignsExportOperatorsIsLoading;
    const colSpan = 2;

    if (oneOfCampaignsDataError) {
      const { errorTitle, errorMessage } = oneOfCampaignsDataError;
      return (
        <Alert
          message={errorTitle}
          description={errorMessage}
          type="error"
        />
      );
    }

    const {
      name,
      scheduleTime,
      segmentCount,
      sender,
      smsBody,
      status,
      deliveredCount,
      type,
      smsCount,
      isMsisdnsWithData
    } = campaign;

    return (
      <AnimateEnter in={isMounted}>
        <ContentWrapper>
          <div style={{position: 'relative'}}>
            <h4 className="title text-pink text-uppercase mb-4"
                style={{
                  display: 'inline-block',
                  marginRight: 10
                }}>
              {name}
            </h4>
            {status === 'DRAFT' && <>
              <Button
                type="primary"
                ghost
                icon="edit"
                shape="circle"
                title={TEXTS.btnEdit[lang]}
                style={{position: 'relative', top: -2, marginRight: 5}}
                onClick={this.toEditCampaign}
              />
              <Popconfirm
                placement="right"
                title={TEXTS.areYouSureToDeleteCampaign[lang]}
                okText={TEXTS.yes[lang]}
                cancelText={TEXTS.btnToCancel[lang]}
                onConfirm={this.deleteCampaign}
              >
                <Button
                  type="danger"
                  ghost={!campaignsDeleteIsLoading}
                  icon="delete"
                  shape="circle"
                  title={TEXTS.btnDelete[lang]}
                  loading={campaignsDeleteIsLoading}
                  style={{position: 'relative', top: -2}}
                />
              </Popconfirm>
              {isMsisdnsWithData &&
                <p style={{position: 'absolute', top: 3, right: 0, marginLeft: 10, fontSize: 12}}>
                  {TEXTS.campaignIsWithMsisdnsData[lang]}
                  <Icon
                    type="solution"
                    style={{position: 'relative', top: -2, marginLeft: 5, fontSize: 18}}
                  />
                </p>}
            </>}
          </div>
          <div className="mb-4">
            <Button
              type="submit"
              className=""
              onClick={this.copyCampaign}>
              <Icon type="copy" />
              {TEXTS.btnCopyCampaign[lang]}
            </Button>
            <Dropdown overlay={() => this.renderMenu(smsCount)} disabled={isExportLoading}>
              <Button style={{verticalAlign: 'bottom'}}>
                {isExportLoading
                  ? <Icon style={{position: 'relative', top: -1}}
                          type="loading" className="text-purple"/>
                  : <Icon style={{position: 'relative', top: -4}}
                          type="export" />}
                {TEXTS.export[lang]}
                <Icon type="down" />
              </Button>
            </Dropdown>
          </div>
          <Descriptions
            column={{
              xxl: 2,
              xl: 2,
              lg: 2,
              md: 2,
              sm: 1,
              xs: 1
            }}
            size="middle"
            bordered
          >
            <Descriptions.Item label={TEXTS.thCampaignStatus[lang]} span={colSpan}>
              <Tag color={CAMPAIGN_STATUSES(lang)[status].color}>
                {CAMPAIGN_STATUSES(lang)[status].text}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label={TEXTS.thCampaignDate[lang]} span={colSpan}>
              {scheduleTime ? moment(scheduleTime).format('DD.MM.YYYY HH:mm:ss') : '—'}
            </Descriptions.Item>
            <Descriptions.Item label={TEXTS.campaignSenderLabel[lang]} span={colSpan}>
              {sender}
            </Descriptions.Item>
            <Descriptions.Item label={TEXTS.smsMessageText[lang]} span={colSpan}>
              <span style={{whiteSpace: 'pre-line'}}>
                {smsBody}
              </span>
            </Descriptions.Item>
            <Descriptions.Item label={TEXTS.thReceiversCount[lang]} span={colSpan}>
              {smsCount}
              {smsCount !== 0 &&
                <Button
                  style={{ marginLeft: 10 }}
                  onClick={() => this.showDrawer(SHOW_MSISDNS)}
                >
                  <Icon type="unordered-list" style={{position: 'relative', top: -4}} />
                  {TEXTS.showMsisdnList[lang]}
                </Button>}
            </Descriptions.Item>
            <Descriptions.Item label={TEXTS.thReceivedSmsCount[lang]} span={colSpan}>
              {deliveredCount}
            </Descriptions.Item>
            <Descriptions.Item label={TEXTS.thUnDeliveredSmsCount[lang]} span={colSpan}>
              {smsCount-deliveredCount}
            </Descriptions.Item>
            <Descriptions.Item label={TEXTS.campaignSmsBodySegmentsCount[lang]} span={colSpan}>
              {segmentCount}
            </Descriptions.Item>
            <Descriptions.Item label={TEXTS.campaignType[lang]} span={colSpan}>
              {type}
            </Descriptions.Item>
          </Descriptions>
        </ContentWrapper>
        <Drawer
            placement={"bottom"}
            closable={false}
            onClose={this.hideDrawer}
            visible={drawerVisible}>
          {this.renderModalForm()}
        </Drawer>
      </AnimateEnter>
    );
  };

  render() {
    if (this.state.oneOfCampaignsDataIsLoading) {
      return(
        <div>
          <ContentWrapper>
            <Empty description={TEXTS.dataIsLoading[this.props.lang]} />
            <div style={{marginTop: 15, textAlign: 'center'}}>
              <Spin spinning={true} />
            </div>
          </ContentWrapper>
        </div>
      );
    }

    return this.renderData();
  }
}

export default CampaignDetails;
